//3rd Party Components
import React, { Fragment } from 'react';
import MetaTags from 'react-meta-tags';
import { AUcallout } from '@gov.au/callout';
import { useState } from 'react';
import { useSelector } from "react-redux";

//Components
import Heading from '../components/CASA/Heading';
import Container from '../components/CASA/Container';
import CASASpinner from '../components/Portal/CASASpinner';

//Actions
import { getPortalUrl, isUUID, UserMustVerifyPOI, UserMustSubmitIndividualARNApplication, getUserHomePage, getParamValue, urlSearchValue } from '../components/Portal/Utilities';
import { getUrlSelector} from '../PortalStore/Selectors/EnvDataSelectors';

export const SingleAircraftOrgPage = () => {
    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(true);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    let aircraft = JSON.parse(atob(decodeURIComponent(urlSearchValue('aircraft'))));
    let organisationId = urlSearchValue('casaorgid');
    if (organisationId === null) {
        organisationId = getParamValue('organisationId');
    }
    let userdetails = useSelector(state => state.userdetails);
    let organisationdetails = useSelector(state => state.organisationDetails);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);

    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    // prevent access if no orgid or invalid organisationId or organisationId not related to user or no rpaid
    if (organisationId.length < 36) {
        organisationId = "";
    }

    if (organisationId === "") {
        history.push("/error?code=ORG.1&standalone=" + standalone);
    }

    //put in utils
    if (participants && participants.items && !participants.items.isParticipant) {
        history.push("/error?code=ORG.2&standalone=" + standalone);
    }

    if (organisationdetails && organisationdetails.items && organisationdetails.items.value && organisationdetails.items.value.length === 0) {
        history.push("/error?code=ORG.3&standalone=" + standalone);
    }

    if (!isUUID(organisationId)) {
        history.push("/error?code=ORG.4&standalone=" + standalone);
    }

    if (organisationdetails && organisationdetails.items && organisationdetails.items.value && organisationdetails.items.value.length === 0) {
        history.push("/error?code=ORG.3&standalone=" + standalone);
    }

    if (!isUUID(organisationId)) {
        history.push("/error?code=ORG.4&standalone=" + standalone);
    }

    const loc = getPortalUrl("/dashorg", standalone, urlHome) + "&casaorgid=" + organisationId;

    let items = [];
    let showItems = false;

    let jparams = {
        'organisationId': organisationId
    }
    
    let item = {
        link: getPortalUrl("/dashorg", standalone, urlHome) + "&casaorgid=" + organisationId + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
        text: 'myCASA'
    }
    items.push(item);
    item = {
        link: getPortalUrl("/manageaircraftorg", standalone, "/forms") + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))),
        text: 'Manage aircraft'
    }
    items.push(item);
    item = {
        text: 'Aircraft details'
    }
    items.push(item);
    
    showItems = true;

    // prevent access if user does not have arn or has not applied for one
    if (UserMustSubmitIndividualARNApplication(userHomePage) || UserMustVerifyPOI(userHomePage)) {
        history.push(userHomePage);
        return null;
    }

    if (!pageLoaded) {
        return (
            <Fragment>
                <MetaTags>
                    <title>Aircraft details</title>
                </MetaTags>

                <Container show={true}>

                    <CASASpinner message="Working. Please wait....." />

                </Container>

            </Fragment>
        )
    }
    else {
        return (
            <Fragment>
                <MetaTags>
                    <title>Aircraft details</title>
                </MetaTags>

                <Heading
                    id="inddronedetails"
                    text="Aircraft details"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={true} />

                <AUcallout
                    title=""
                    srOnlyTitle>
                    <h4>Please ensure these aircraft details are correct</h4>
                    <p>If the aircraft manufacturer, type, serial number or registration holder / registered operator have changed, <a href="https://www.casa.gov.au/aircraft/civil-aircraft-register/aircraft-registration">you must inform CASA of these changes</a>. If the aircraft should no longer be registered you must submit a <a href="https://www.casa.gov.au/aircraft/civil-aircraft-register/aircraft-registration">cancellation of aircraft registration</a>.</p>
                    <p>Please also ensure your <a href={"/profiledetailsorg?casaorgid="+organisationId}>organisation&apos;s details</a> are up to date.</p>
                </AUcallout>

                <h2 className="au-display-md">VH-Mark</h2>
                {aircraft.vhmark}
                <h2 className="au-display-md">Category</h2>
                {aircraft.category}
                <h2 className="au-display-md">Manufacturer</h2>
                {aircraft.manufacturer}
                <h2 className="au-display-md">Model</h2>
                {aircraft.model}
                <h2 className="au-display-md">Year of manufacture</h2>
                {aircraft.yearOfManufacture}
                <h2 className="au-display-md">Serial number</h2>
                {aircraft.serialno}
                <h2 className="au-display-md">Number of engines</h2>
                {aircraft.numberOfEngines}

                {aircraft.partOwner ?
                    <h2 className="au-display-md">Registration holder (main owner)</h2>
                    :
                    <h2 className="au-display-md">Registration holder</h2>
                }
                {aircraft.mainOwner.fullname}
                <br />
                {aircraft.mainOwner.postalAddress}
                <br />
                {aircraft.mainOwner.phone !== "" ?
                    <Fragment>
                        {aircraft.mainOwner.phone}
                        <br />
                    </Fragment>
                    : null
                }
                {aircraft.mainOwner.email}

                {aircraft.partOwner ?
                    <Fragment>
                        <h2 className="au-display-md">Registration holder (part owner)</h2>
                        {aircraft.partOwner.fullname}
                        <br />
                        {aircraft.partOwner.postalAddress}
                        <br />
                        {aircraft.partOwner.phone !== "" ?
                            <Fragment>
                                {aircraft.partOwner.phone}
                                <br />
                            </Fragment>
                            : null
                        }
                        {aircraft.partOwner.email}
                    </Fragment>
                    : null
                }
                <h2 className="au-display-md">Registration holder commencement date</h2>
                {aircraft.mainOwner.commencementDate}

                <h2 className="au-display-md">Aircraft first registered in Australia</h2>
                {aircraft.initially}

                <h2 className="au-display-md">Registered Operator</h2>
                {aircraft.mainOperator.fullname}
                <br />
                {aircraft.mainOperator.postalAddress}
                <br />
                {aircraft.mainOperator.phone !== "" ?
                    <Fragment>
                        {aircraft.mainOperator.phone}
                        <br />
                    </Fragment>
                    : null
                }
                {aircraft.mainOperator.email}

                <h2 className="au-display-md">Registered operator commencement date</h2>
                {aircraft.mainOperator.commencementDate}

                <div className="au-form-group" >
                    <a className="au-direction-link" href={loc}>
                        <span className="au-direction-link__arrow au-direction-link__arrow--left" />
                        Return to myCASA
                    </a>
                </div>

            </Fragment>
        );
    }
}
